module.exports = __webpack_public_path__ + "static/media/1-2.bf559a5d.webp";